import { type FC, useMemo } from 'react';

import type IGameSettings from '../../../../../../types/models/IGameSettings';
import { BANNER_TAG, resolveGameBanner } from '../../../../constants/gameBanners';
import StatisticRtpGameBanner from '../StatisticRtpGameBanner/StatisticRtpGameBanner';
import TopGameBanner from '../TopGameBanner/TopGameBanner';
import NewGameBanner from '../NewGameBanner/NewGameBanner';

interface GameBannerProps {
  gameData: IGameSettings;
  sectionName: string;
}

/**
 * A card shows at most one corner banner. The winning tag is resolved by
 * priority (hot/cold RTP > top > new); this component maps that tag to its
 * banner. The RTP banner itself returns null when there is no statisticRtp.
 */
const GameBanner: FC<GameBannerProps> = ({ gameData, sectionName }) => {
  const bannerTag = useMemo(
    () => resolveGameBanner(gameData.gameBanners, sectionName),
    [gameData.gameBanners, sectionName],
  );

  switch (bannerTag) {
    case BANNER_TAG.HOT:
    case BANNER_TAG.COLD:
      return <StatisticRtpGameBanner gameStatisticRtp={gameData.statisticRtp} hotOrCold={bannerTag} />;
    case BANNER_TAG.TOP:
      return <TopGameBanner />;
    case BANNER_TAG.NEW:
      return <NewGameBanner />;
    default:
      return null;
  }
};

export default GameBanner;
